import { ReactNode, AnchorHTMLAttributes } from 'react'

type LinkWeight = 'default' | 'semi'

const weightClasses: Record<LinkWeight, string> = {
	default: 'spaces:font-default',
	semi: 'spaces:font-semi'
}

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	label: string
	defaultUnderline?: boolean
	weight?: LinkWeight
	iconLeft?: ReactNode
	iconRight?: ReactNode
	spacesClass?: string
}

export function Link ({
	label,
	defaultUnderline = true,
	weight = 'default',
	iconLeft,
	iconRight,
	spacesClass = '',
	className = '',
	...props
}: LinkProps) {
	return (
		<a
			data-underline={String(defaultUnderline)}
			className={`spaces-link spaces:inline-flex spaces:items-center spaces:gap-4 ${weightClasses[weight]} spaces:cursor-pointer ${spacesClass} ${className}`}
			{...props}
		>
			{iconLeft}
			<span>{label}</span>
			{iconRight}
		</a>
	)
}
